var map = {
	"./ar/sound/index.vue": [
		9041,
		8568,
		9041
	],
	"./bn/sound/index.vue": [
		8034,
		8568,
		8034
	],
	"./en/sound/index.vue": [
		5718,
		8568,
		5718
	],
	"./fa/sound/index.vue": [
		1821,
		8568,
		1821
	],
	"./ur/sound/index.vue": [
		4192,
		8568,
		4192
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5820;
module.exports = webpackAsyncContext;